import React, { useState, useEffect } from 'react';
import { REGS, RT } from './registers';
import { I18n } from 'aws-amplify/utils';

import { pubsub } from './utils/pubsub';
import { Amplify } from 'aws-amplify';
import * as subscriptions from './graphql/subscriptions';
// import { withAuthenticator } from '@aws-amplify/ui-react';

import config from './amplifyconfiguration.json';

import { lightFormat } from 'date-fns';

import { DeviceView } from './components/DeviceView';
import { HomeView, selectedView_t } from './components/HomeView';
import { AppShell } from './components/AppShell';
import { useDeviceSubscription } from './hooks/useDeviceSubscription';
import { useAuth } from './hooks/useAuth';
import { AuthProvider } from './contexts/AuthContext';
import { ConnectionProvider } from './contexts/ConnectionContext';
import { DeviceProvider } from './contexts/DeviceContext';
import { UpgradeProvider } from './contexts/UpgradeContext';
import { useDevices } from './hooks/useDevices';
import { useUpgradeFlow } from './hooks/useUpgradeFlow';
import { Grid } from './components/TremorCompat';

import '@aws-amplify/ui-react/styles.css';
import 'rsuite/dist/rsuite.min.css';
import './App.css';

import { formatTemperature } from './components/RegistersHandler';

import { ViewErrorBoundary } from './components/ErrorFallback';
import { datetimeFormats, faultView, statusItems, modelTypeItems, tabItems } from './constants';

import { client, timer } from './utils/apiClient';
import { devLog } from './utils/devLog';

// global.ResizeObserver = jest.fn().mockImplementation(() => {
//   return {
//     observe: jest.fn(),
//     disconnect: jest.fn(),
//     unobserve: jest.fn()
//   }
// })

Amplify.configure(config);

// function App({ signOut, user }) {
//   return (
//     <>
//       <h1>Hello {user.username}</h1>
//       <button onClick={signOut}>Sign out</button>
//     </>
//   );
// }

I18n.putVocabularies({
  en: {
    'Custom auth lambda trigger is not configured for the user pool.': 'Password cannot be empty',
  },
});

const useOnWindowResize = (callback) => {
  // Keep the latest callback in a ref, updated every render, so the
  // subscription effect below can depend on nothing and run exactly once
  // instead of removing/re-adding a real DOM listener on every render (the
  // inline arrow function App() passes in has a new identity each time).
  // Written directly during render (not in a passive effect) so there's no
  // window between a re-render committing and a resize event firing where
  // the ref would still point at the previous render's callback. Safe to
  // write during render here specifically because callbackRef.current is
  // never *read* until later — inside the resize listener below — never
  // during render itself.
  const callbackRef = React.useRef(callback);
  callbackRef.current = callback;

  React.useEffect(() => {
    const listener = (...args) => callbackRef.current(...args);
    window.addEventListener('resize', listener);
    return () => {
      window.removeEventListener('resize', listener);
    };
  }, []);
};

const useHideUnimportantErrors = () => {
  useEffect(() => {
    function hideError(e) {
      if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
        const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
        const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute('style', 'display: none');
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute('style', 'display: none');
        }
      }
    }

    window.addEventListener('error', hideError);
    return () => {
      window.removeEventListener('error', hideError);
    };
  }, []);
};

function App() {
  //window.ResizeObserver = undefined;
  useHideUnimportantErrors();
  useOnWindowResize(() => devLog(`Window size: (${window.innerWidth}, ${window.innerHeight})`));

  // Subscribe to update of Todo
  useEffect(() => {
    const sub = client.graphql({ query: subscriptions.onUpdateInformation }).subscribe({
      next: ({ data }) => devLog('***** Subscription has changed:', data, ' *****'),
      error: (error) => console.warn(error),
    });
    return () => sub.unsubscribe();
  }, []);

  const devicesApiRef = React.useRef(null);

  const onSignedOut = () => {
    devicesApiRef.current?.resetOnSignOut();
    setSelectedView(selectedView_t.GRID);
    setSelectedStatus(statusItems.all);
    setSelectedFilter(null);
    setSelectedModelFilter(null);
    setselectedModel(modelTypeItems.all);
    setSelectedFaultView(faultView.current);
  };
  const auth = useAuth({ onSignedOut });
  const { loginId, userGroups, accessLevel, setAccessLevel } = auth;
  const [selectedStatus, setSelectedStatus] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [selectedModelFilter, setSelectedModelFilter] = useState(null);
  const [selectedModel, setselectedModel] = useState(0);

  const [selectedView, setSelectedView] = useState(0);
  const [selectedFaultView, setSelectedFaultView] = useState(0);
  // const [selectedLatestFaults, setSelectedLatestFaults] = useState([]);
  const [selectedHistoryFaults, setSelectedHistoryFaults] = useState([]);

  const [showDevice, setShowDevice] = useState(false);

  // const [loaded, setLoaded] = useState(false)

  const [activeKey, setActiveKey] = useState(tabItems.home);
  const [editOff, setEditOff] = useState(true);
  const [showArchivedDevices, setShowArchivedDevices] = useState(false);

  const upgradeFlow = useUpgradeFlow();
  // Only the in-progress setters are still read here — they are handed to
  // useDeviceSubscription so incoming register messages can clear the flags.
  // Everything else useUpgradeFlow returns now reaches the firmware cards
  // through UpgradeProvider below rather than as props on <DeviceView>.
  const {
    setUpdateInProgress,
    setACUpdateInProgress,
    setSH1UpdateInProgress,
    setSH2UpdateInProgress,
    setPowerUpdateInProgress,
    setIOUpdateInProgress,
  } = upgradeFlow;

  const devicesApi = useDevices({ loginId, userGroups, accessLevel, setAccessLevel });
  useEffect(() => {
    devicesApiRef.current = devicesApi;
  });
  const {
    devices,
    setDevices,
    loading,
    loadingLogs,
    loadingConfig,
    progress,
    selectedDevices,
    selectedFilterDateRange,
    setSelectedFilterDateRange,
    selectedDateRange,
    accessableGroups,
    accessableDevices,
    god_mode,
    installedBy,
    selectedSortKey,
    selectedSortOrder,
    currentDevice,
    devicesStats,
    configuredAppliances,
    getPumpTrackerdata,
    handleSelectedDevice,
    refreshFaultDataByDate,
    updateSelectedDevices,
    sortDevicesArray,
    sortDevices,
    handlerSortChanged,
    updateDeviceLocalArchiveStatus,
    updateLocalDeviceName,
    updateLocalUserDeviceName,
    updateDeviceName,
    updateUserDeviceName,
    fetchDeviceAccess,
    fetchSetPointData,
    fetchLogData,
    fetchFaultsData,
  } = devicesApi;

  const subscription = useDeviceSubscription(currentDevice, {
    setUpdateInProgress,
    setACUpdateInProgress,
    setSH1UpdateInProgress,
    setSH2UpdateInProgress,
    setPowerUpdateInProgress,
    setIOUpdateInProgress,
  });
  const { macAddress, registerData } = subscription;

  async function writeRegisters(StartAddress, values) {
    const topic = 'dontek' + macAddress + '/cmd/psw';
    const message = { messageId: 'write', modbusReg: StartAddress, modbusVal: values };
    await pubsub.publish({
      topics: topic,
      message: message,
      options: { provider: 'AWSIoTProvider' },
    });

    devLog(topic, '=>', message);
    await timer(250);
  }

  const handleBackFromDevice = () => {
    setShowDevice(false);
    if (subscription.disconnect()) {
      devicesApi.resetForBackNavigation();
      setEditOff(true);
    }
  };

  // function addAfter(array, index, newItem) {
  //   return [
  //       ...array.slice(0, index),
  //       newItem,
  //       ...array.slice(index)
  //   ];
  // }

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const createBatches = (registers) => {
    var templateBatch1 = [];
    var templateBatch2 = [];
    var templateBatch3 = [];
    registers.forEach((item) => {
      var regAddress = item.address;
      if (
        regAddress === REGS.SLAVE_1_ENABLE ||
        regAddress === REGS.SLAVE_2_ENABLE ||
        regAddress === REGS.SLAVE_3_ENABLE || // Expansion
        (regAddress >= REGS.AUTO_SET_TIME && regAddress <= REGS.ADJUST_DST)
      ) // Auto set time
      {
        devLog('Add register', regAddress, 'to template batch 1', item);
        templateBatch1.push(item);
      } else if (
        (regAddress >= REGS.SOCKET_1_TYPE && regAddress <= REGS.VFCONTACT_1_TYPE) ||
        regAddress === REGS.VFCONTACT_2_TYPE
      ) // Appliance types
      {
        // console.log( "Add register",regAddress, "to template batch 2", item)
        templateBatch2.push(item);
      } else {
        templateBatch3.push(item);
      }
    });
    return { batch1: templateBatch1, batch2: templateBatch2, batch3: templateBatch3 };
  };

  const groupRegistersByRanges = (regs, rangeMax = 15) => {
    var ranges = [];
    if (regs !== undefined && regs.length > 0) {
      var regStart = [];
      var regCount = 0;
      var regValue = 0;
      var idx = -1;
      var isKeyPresent = false;
      for (var i = 0; i < regs.length; i++) {
        if (i === 0 || regs[i].address !== regs[i - 1].address + 1 || regCount >= rangeMax) {
          regStart = regs[i];
          idx++;
        }
        regValue = regs[i].value;
        if (regStart !== undefined) {
          let our_address = regStart.address;
          isKeyPresent = ranges.some((el) => el.startAddress === our_address);

          if (!isKeyPresent) {
            var item = { startAddress: regStart.address, values: [] };
            ranges.push(item); // = addAfter(ranges,idx,item)
            regCount = 0;
          }

          ranges[idx].values.push(regValue);
          regCount++;
        }
      }
    }
    return ranges;
  };

  async function doSaveData() {
    const registersFiltered = registerData.filter((item) => item.reg_type === RT.Holding);
    const registersAscending = [...registersFiltered].sort((a, b) => a.address - b.address);
    const newRegisters = registersAscending.map((item) => ({ address: item.address, value: item.value }));
    devLog(newRegisters);
    const fileData = JSON.stringify(newRegisters);
    const blob = new Blob([fileData], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    const dt0 = new Date();
    link.download = currentDevice.uniqueDeviceId + '_' + lightFormat(dt0, datetimeFormats.filename_long);
    link.href = url;
    link.click();
    URL.revokeObjectURL(url);
    return link.download;
  }

  // import {useRef} from 'react';
  function doLoadData(file) {
    // Resolve once the file has been parsed and every register write has
    // actually completed — not merely been dispatched — so the caller's
    // "Data restored from …" status reflects the device, and a failed write
    // rejects the restore instead of surfacing as an unhandled rejection.
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsText(file, 'UTF-8');
      fileReader.onerror = () => reject(fileReader.error);
      fileReader.onload = async (item) => {
        try {
          devLog('e.target.result', item.target.result);
          const data = JSON.parse(item.target.result);
          devLog('Json Data', data);
          const dataAscending = [...data].sort((a, b) => a.address - b.address);
          devLog('Json Sorted Data', dataAscending);
          const batchedRegister = createBatches(dataAscending);
          devLog('batched Sorted Data', batchedRegister);
          const groupedRegisters1 = groupRegistersByRanges(batchedRegister.batch1, 15);
          devLog('group Sorted Data', groupedRegisters1);
          const groupedRegisters2 = groupRegistersByRanges(batchedRegister.batch2, 15);
          devLog('group Sorted Data', groupedRegisters2);
          const groupedRegisters3 = groupRegistersByRanges(batchedRegister.batch3, 15);
          devLog('group Sorted Data', groupedRegisters3);
          // Dispatch order and concurrency are unchanged from before — all
          // three batches go out together, as they always have. The only
          // difference is that we now wait for them and propagate a failure.
          await Promise.all(
            [...groupedRegisters1, ...groupedRegisters2, ...groupedRegisters3].map((item) =>
              writeRegisters(item.startAddress, item.values),
            ),
          );
          resolve();
        } catch (error) {
          reject(error);
        }
      };
    });
  }

  // useEffect(() => {
  //   async function logIdentityInfo() {
  //     try {
  //     const session = await fetchAuthSession();
  //     // Identity Pool ID
  //     console.log('Identity Pool ID:', session.identityId?.split(':')[0]);
  //     // Full Identity ID
  //     console.log('Identity ID:', session.identityId);
  //     // IAM Role ARN
  //     if (session.credentials) {
  //       console.log('Current AWS Role ARN:', session.credentials.authenticatedRoleArn || session.credentials.unauthenticatedRoleArn);
  //     } else {
  //       console.log('No credentials found.');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching identity info:', error);
  //   }
  //   }
  //   logIdentityInfo();
  // }, []);

  const handleViewDevice = (device) => {
    setEditOff(true);
    setActiveKey(tabItems.home);
    devicesApi.viewDevice(device);
    setShowDevice(true);
  };

  const Content = () => {
    return (
      <Grid numItems={1} className="gap-2 sm:p-4">
        {showDevice === false && (
          <ViewErrorBoundary name="Home">
            <HomeView
              devices={devices}
              selectedDevices={selectedDevices}
              selectedStatus={selectedStatus}
              selectedFilter={selectedFilter}
              selectedModelFilter={selectedModelFilter}
              selectedModel={selectedModel}
              selectedView={selectedView}
              selectedSortKey={selectedSortKey}
              selectedSortOrder={selectedSortOrder}
              selectedDateRange={selectedDateRange}
              selectedFilterDateRange={selectedFilterDateRange}
              showArchivedDevices={showArchivedDevices}
              loading={loading}
              progress={progress}
              onSelectedDevicesChanged={updateSelectedDevices}
              onSelectedStatusChanged={setSelectedStatus}
              onSelectedFilterChanged={setSelectedFilter}
              onSelectedModelFilterChanged={setSelectedModelFilter}
              onSelectedModelTypeChanged={setselectedModel}
              onSelectedViewChanged={setSelectedView}
              onSelectedSortChanged={handlerSortChanged}
              onRefresh={fetchDeviceAccess}
              onToggleArchivedDevices={setShowArchivedDevices}
              onUpdateDeviceName={updateDeviceName}
              onUpdateUserDeviceName={updateUserDeviceName}
              onUpdateDeviceLocalArchiveStatus={updateDeviceLocalArchiveStatus}
              onSelectedFaultDateRangeChanged={refreshFaultDataByDate}
              onSelectedDateRangeChanged={setSelectedFilterDateRange}
              devicesStats={devicesStats}
              // onViewTrends={handleViewTrends}
              // onViewFaults={handleViewFaults}
              // onViewDashboard={handleViewDashboard}
              onViewDevice={handleViewDevice}
            />
          </ViewErrorBoundary>
        )}
        {showDevice === true && (
          <ViewErrorBoundary name="Device" onReset={() => handleSelectedDevice('')}>
            <ConnectionProvider value={subscription}>
              <DeviceProvider value={devicesApi}>
                <UpgradeProvider value={upgradeFlow}>
                  <DeviceView
                    device={currentDevice}
                    onSelectedModelTypeChanged={setselectedModel}
                    // device={selectedDevice}
                    // applianceDataArray={applianceDataArray}
                    onSaveData={doSaveData}
                    onLoadData={doLoadData}
                    // latestFaults={latestFaults}
                    onSelectedStatusChanged={setSelectedStatus}
                    onSelectedViewChanged={setSelectedView}
                    onSetSelectedFaultView={setSelectedFaultView}
                    onSetSelectedHistoryFaults={setSelectedHistoryFaults}

                    onSetActiveKey={setActiveKey}
                    activeKey={activeKey}
                    onSetEditOff={setEditOff}
                    editOff={editOff}
                    onBackPressed={handleBackFromDevice}

                    selectedHistoryFaults={selectedHistoryFaults}
                    selectedFaultView={selectedFaultView}
                    formatTemperature={formatTemperature}
                  />
                </UpgradeProvider>
              </DeviceProvider>
            </ConnectionProvider>
          </ViewErrorBoundary>
        )}
      </Grid>
    );
  };

  return (
    <AuthProvider value={auth}>
      {/* Content() is CALLED, not rendered as <Content />. It is defined inside
          App, so `<Content />` gave React a brand-new component type on every
          App render — React then unmounted and remounted the whole subtree,
          destroying HomeView's and DeviceView's local state each time any App
          state changed. That is why the SWC slot radios reverted to Main on
          pressing Upgrade or Edit. Calling it inlines the JSX instead, so the
          tree reconciles normally. Content uses no hooks, so calling it here is
          safe; if it ever needs any, lift it to module scope with explicit
          props rather than reverting to <Content />. */}
      <AppShell content={Content()} />
    </AuthProvider>
  );
}

export default App;
